import CreditIcon from 'src/assets/icons/CreditIcon.svg';
import type { CreditsTier } from './types';
import { formatGrouped, perCreditPrice } from './utils';
import {
  BigCredits,
  BonusPill,
  PerCreditNote,
  Price,
  PriceRow,
  ReadLeft,
  ReadRight,
  ReadRow,
  StrikePrice,
} from './styles/CreditsReadout.styles';

export type CreditsReadoutProps = {
  tier: CreditsTier;
  compact?: boolean;
};

const CreditsReadout = ({ tier, compact }: CreditsReadoutProps) => {
  const totalCredits = tier.credits + tier.bonusCredits;
  const hasStrike = !!tier.strikePrice && tier.strikePrice > tier.price;

  return (
    <ReadRow compact={compact}>
      <ReadLeft>
        <BigCredits compact={compact}>
          <img src={CreditIcon} alt="" />
          {formatGrouped(tier.credits)}&nbsp;credits
        </BigCredits>
        {tier.bonusCredits > 0 && (
          <BonusPill>
            <img src={CreditIcon} alt="" />+{formatGrouped(tier.bonusCredits)}{' '}
            bonus
          </BonusPill>
        )}
      </ReadLeft>
      <ReadRight compact={compact}>
        <PriceRow compact={compact}>
          <Price compact={compact}>₹{formatGrouped(tier.price)}</Price>
          {hasStrike && (
            <StrikePrice>₹{formatGrouped(tier.strikePrice!)}</StrikePrice>
          )}
        </PriceRow>
        <PerCreditNote>
          ₹{perCreditPrice(tier.price, totalCredits).toFixed(2)} per credit
        </PerCreditNote>
      </ReadRight>
    </ReadRow>
  );
};

export default CreditsReadout;
